(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('NavbarSectionController', NavbarSectionController);

    NavbarSectionController.$inject = ['__config', '$location', '$window', '$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', 'UserCustom', '$scope', 'CompanyInfoQuery', 'CompanyCustom', '$rootScope', '$translate', '$localStorage', '$uibModal', 'CompanySubscriptionStatusCustom'];

    function NavbarSectionController(__config, $location, $window, $state, Auth, Principal, ProfileService, LoginService, UserCustom, $scope, CompanyInfoQuery, CompanyCustom, $rootScope, $translate, $localStorage, $uibModal, CompanySubscriptionStatusCustom) {
        var vm = this;

        vm.appVersion = 'v3';
        setCurrentCompany();

        function setCurrentCompany() {
            if (Principal.isAuthenticated()) {

                CompanyInfoQuery.getCurrentCompanyInfo().query(function (c) {

                    if (c && c.appVersion && c.appVersion == 'v3')
                        vm.appVersion = 'v3';
                    else
                        vm.appVersion = 'v2';

                });

            }
        }

    }
})();
